import firebase from "firebase";
import {InfoStoreUtils} from "@/modules/minfo/database/InfoStoreUtils";

export default {
    namespaced: true,
    state: {
        mUsersCountPerApp:[],
        mUsersCountPerPackage:[],
    },
    getters: {
        getUsersCountPerApp: state => {
            return state.mUsersCountPerApp;
        },
        getUsersCountPerPackage: state => {
            return state.mUsersCountPerPackage;
        },
    },
    mutations: {
        setUsersCountPerApp(state, values) {
            state.mUsersCountPerApp = values;
        },
        setUsersCountPerPackage(state, values) {
            state.mUsersCountPerPackage = values;
        },
    },
    actions: {
        init(/*{commit}*/) {
            console.info('info-store initialized.');
        },
        fethUsersCountPerApp({commit}){
            commit('setUsersCountPerApp', [])
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getUsersCountPerApp', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            commit('setUsersCountPerApp', JSON.parse(data) || [])
                                        }).catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fethUsersCountPerPackage({commit}){
            commit('setUsersCountPerPackage', [])
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getUsersCountPerPackage', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            commit('setUsersCountPerPackage', JSON.parse(data) || [])
                                        }).catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        removeUsersCountPerApp({/*commit*/}, data){
            console.log(data)
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body:JSON.stringify(data),
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeUsersCountPerApp', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return InfoStoreUtils.fethUsersCountPerApp()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

